import DailyTileMatch from './DailyTileMatch.js';
import manifest from './manifest.js';
import type { GameRuntimeFactory } from '@adgf/game-engine';

export { default as DailyTileMatch } from './DailyTileMatch.js';
export { default as manifest } from './manifest.js';

/**
 * Runtime factory — creates a new DailyTileMatch instance.
 */
export const createRuntime: GameRuntimeFactory = (config, events) => {
  return new DailyTileMatch(config, events);
};

export default manifest;
